import { Alert } from '@dtx-company/design-system/src'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { useRouter } from 'next/router'
import React, { useMemo } from 'react'
import ResendVerificationEmailButton from '../ResendVerificationEmailButton'
import useTranslation from 'next-translate/useTranslation'

const PendingBanner: React.FC = () => {
  const { pathname, isReady } = useRouter()
  const { t } = useTranslation('email-verification')

  const copy = useMemo(() => {
    let copytag = 'other'

    if (isReady && pathname === Routes.CODES) copytag = 'code'
    if (isReady && pathname === Routes.PAGES) copytag = 'page'

    return t(`views.PendingBanner.${copytag}`)
  }, [isReady, pathname, t])

  return (
    <Alert
      severity="info"
      action={
        <ResendVerificationEmailButton
          additionalCallback={() => {
            fireAnalyticsEvent('EmailVerif_ReminderBanner_Clicked_ResendEmail')
          }}
        />
      }
    >
      {copy}
    </Alert>
  )
}

export default PendingBanner
